import { render, staticRenderFns } from "./Indians.vue?vue&type=template&id=e95dfec8&"
import script from "./Indians.vue?vue&type=script&lang=js&"
export * from "./Indians.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports